import { render, staticRenderFns } from "./typeahead_internal_user.vue?vue&type=template&id=70f0b96e"
import script from "./typeahead_internal_user.vue?vue&type=script&lang=js"
export * from "./typeahead_internal_user.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports